import { render, staticRenderFns } from "./Ingresos.vue?vue&type=template&id=67fffc78&scoped=true&lang=html&"
import script from "./Ingresos.vue?vue&type=script&lang=js&"
export * from "./Ingresos.vue?vue&type=script&lang=js&"
import style0 from "./Ingresos.vue?vue&type=style&index=0&id=67fffc78&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fffc78",
  null
  
)

export default component.exports